export default __webpack_public_path__ + "static/media/752.d971e9ca.png";